import type { FaireProductEntity } from "../../entity_types/product";

export const p_5knne4f7cz: FaireProductEntity = {
  token: "p_5knne4f7cz",
  type: "product",
  name: 'Rainbow Shape Doormat-15x30"L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/4e7556c35a3bc5459ae2c1f9eb3016d1a4abccdae78473f955f9356b46efa791.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5afd21a5a4972d9a50a6a31c64a7a286dc391523eaaad3719931d205b2203037.jpeg",
  ],
  priceDollars: 15,
  description:
    "This vibrant Rainbow Shaped Doormat makes a bright and cheery addition to any front door. Crafted out of durable coir fibre, this brightly-coloured mat — diecut in the shape of a rainbow — is made to withstand the harshest of weather conditions and keep on shining! Made in India.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:12.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
